import { TrafficSituationHelper } from '../../../helpers/traffic-situation.helper';
import { TransportModeHelper } from '../../../helpers/transport-mode.helper';
import { IServerSideRendered } from '../../Shared/Base/server-side-rendered';
import LineListFact from '../components/facts/LineListFact';
import MunicipalitiesFact from '../components/facts/MunicipalitiesFact';
import StopAreasFact from '../components/facts/StopAreasFact';
import ValidityPeriodFact from '../components/facts/ValidityPeriodFact';
import TrafficSituationApiModel from '../models/traffic-situation.api-model';

export type ITrafficInformationDetailsV2Texts = object;

export interface ITrafficInformationDetailsV2Settings {
  trafficSituation: TrafficSituationApiModel;
}

export type ITrafficInformationDetailsV2Props = IServerSideRendered<ITrafficInformationDetailsV2Texts, ITrafficInformationDetailsV2Settings>;

export default function TrafficInformationDetailsV2({ settings }: ITrafficInformationDetailsV2Props) {
  const trafficSituation = TrafficSituationApiModel.mapToBusinessModel(settings.trafficSituation);

  if (!trafficSituation) {
    return null;
  }

  const affectedMunicipalities = TrafficSituationHelper.getAffectedMunicipalities(trafficSituation);
  const affectedStopAreas = TrafficSituationHelper.getAffectedStopAreas(trafficSituation);

  return (
    <div className="d-flex flex-column flex-grow-1 gap-3">
      <LineListFact trafficSituation={trafficSituation} showWithDirectionName={TransportModeHelper.all} />
      <StopAreasFact stopAreas={affectedStopAreas} />
      <MunicipalitiesFact municipalities={affectedMunicipalities} />
      <ValidityPeriodFact trafficSituation={trafficSituation} />
    </div>
  );
}
